import React from 'react';
import styles from './Insight.module.css';
import { FCWithChildren } from '../../utility/utility.types';

const Insight: FCWithChildren = ({ children }) => {
    return <div className={styles.insight}>{children}</div>;
};

export default Insight;
